import { render } from "./Car.vue?vue&type=template&id=2e221354"
import script from "./Car.vue?vue&type=script&lang=js"
export * from "./Car.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__